//--INTERNAL IMPORTS
import { MainPageLayout } from "layout";

const App = () => {
    return (
        <>
            <MainPageLayout />
        </>
    );
};

export default App;
